import { http } from "../api/http";

export const emailService = {
  send,
};

async function send(payload) {
  const url = `/email`;
  const response = await http.post(url, payload);
  return response;
}
